import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import CSSModules from 'react-css-modules';

import { IconButton } from '../Button/IconButton';
import { COLORS } from '../../constants/styles';
import styles from './index.styl';

function PopoverContent({ list, description, onClose }) {
  return (
    <div styleName="content" onClick={event => event.stopPropagation()}>
      <IconButton
        styleName="close"
        name="close"
        size={16}
        fill={COLORS.fontLighter}
        onClick={onClose}
      />
      <If condition={!isEmpty(list)}>
        {list.map(row => (
          <div styleName="row" key={Math.random()}>
            {row.map(({ title, subtitle }) => (
              <div styleName="item" key={title}>
                <p styleName="title">{title}</p>
                <p styleName="subtitle">{subtitle}</p>
              </div>
            ))}
          </div>
        ))}
      </If>
      <If condition={Boolean(description)}>
        <div styleName="row">
          <p styleName="subtitle">{description}</p>
        </div>
      </If>
    </div>
  );
}

PopoverContent.propTypes = {
  list: PropTypes.array,
  onClose: PropTypes.func,
  description: PropTypes.string,
};

export default CSSModules(PopoverContent, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/InfoPopover/PopoverContent.jsx